import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Reset scroll position to top whenever the route changes.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, [pathname]);
  return null;
}